import { render, staticRenderFns } from "./warehousePankuiSummary.vue?vue&type=template&id=37d7e3e9&"
import script from "./warehousePankuiSummary.vue?vue&type=script&lang=js&"
export * from "./warehousePankuiSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports